import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import '../styles/newproject.scss';

const NewProject = () => {
  return (
    <>
      <Seo />
      <div className="newproject">
        <section className="newproject-hero">
          <div className="hero-content">
            <h1 className="newproject-hero__title">NEW PROJECTS</h1>
            <p className="newproject-hero__subtitle">
              Let's create something remarkable together. Provide a quick overview of your project.
            </p>
          </div>
        </section>

        <section className="section project-form">
          <div className="wrapper">
            <div className="form-container">
              <form className="project-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label mono">Your Name</label>
                    <input type="text" id="name" name="name" className="form-input" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label mono">Email Address</label>
                    <input type="email" id="email" name="email" className="form-input" required />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="timeline" className="form-label mono">Timeline</label>
                  <select id="timeline" name="timeline" className="form-select">
                    <option value="">Select timeline</option>
                    <option value="asap">ASAP</option>
                    <option value="1-3-months">1-3 months</option>
                    <option value="3-6-months">3-6 months</option>
                    <option value="6-plus-months">6+ months</option>
                    <option value="flexible">Flexible</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="budget" className="form-label mono">Budget Range</label>
                  <select id="budget" name="budget" className="form-select">
                    <option value="">Select budget range</option>
                    <option value="up-to-2500">Up to £2,500</option>
                    <option value="2500-5000">£2,500 - £5,000</option>
                    <option value="5k-15k">£5,000 - £15,000</option>
                    <option value="15k-30k">£15,000 - £30,000</option>
                    <option value="30k-50k">£30,000 - £50,000</option>
                    <option value="discuss">Let's discuss</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="brief" className="form-label mono">Upload Brief (optional)</label>
                  <input
                    type="file"
                    id="brief"
                    name="brief"
                    className="form-input form-file"
                    accept=".pdf,.doc,.docx,.ppt,.pptx,.zip,.fig,.sketch,.xd"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="description" className="form-label mono">Project Description</label>
                  <textarea id="description" name="description" className="form-textarea" rows="6" placeholder="Tell us about your project, goals, and what you're looking to achieve..."></textarea>
                </div>

                <div className="form-actions">
                  <button type="submit" className="submit-button mono">
                    Send Project Brief
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NewProject;
